var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCercledeuxcasdefigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303.45 397.64",
    style: {
      enableBackground: "new 0 0 303.45 397.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.45,360.17c-30.33,19.74-66.48,31.26-105.29,31.13C92.03,390.93,5.98,304.3,6.34,198.16 C6.7,92.03,93.34,5.98,199.47,6.34c38.36,0.13,74,11.65,103.98,31.17v-7.66C273.23,11.06,237.62,0.13,199.49,0 C89.86-0.37,0.37,88.51,0,198.14c-0.37,109.63,88.51,199.12,198.14,199.49c38.62,0.13,74.71-10.85,105.31-29.87V360.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCercledeuxcasdefigure);
export default __webpack_public_path__ + "static/media/cercle deux cas de figure.369dfa9927f7d5058ce0f5c464d49830.svg";
export { ForwardRef as ReactComponent };